import { ApiClientError } from "../../api/client.js";
import { canvasCopy } from "../../copy/zh-CN.js";

const messages = {
  unsupported: "素材格式不支持或文件损坏。请使用可正常播放的 MP4/MOV 视频、MP3/WAV 音频或常用图片。",
  mismatch: "文件声明格式与实际格式不一致。请从原软件重新导出，不要只修改扩展名。",
  tooLarge: "素材大小超出限制：图片 30 MB、视频 50 MB、音频 15 MB。请压缩或剪短后上传。",
  empty: "不能上传空文件。请确认文件已完整保存后重新选择。",
  login: "登录状态已失效，请重新登录后上传。",
  forbidden: "上传校验或权限未通过。请刷新页面后重试；仍失败时请联系管理员。",
  missingProject: "项目不存在或你没有访问权限。请返回项目列表确认后再上传。",
  network: "网络中断，尚不能确认上传结果。请先刷新素材列表确认是否已上传，避免重复上传。",
  busy: "上传请求过于频繁，请稍后重试。",
  server: "服务器处理素材失败。请保留请求编号并联系管理员，不要连续重复上传。",
  placement: "素材已上传，但添加到画布失败。重试只会重新添加到画布，不会重复上传。",
  unknown: canvasCopy.uploadFailed
} as const;

export interface UploadFailure {
  reason: keyof typeof messages;
  requestId?: string;
}

const requestIdPattern = /^[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}$/iu;

export function classifyUploadFailure(error: unknown): UploadFailure {
  if (!(error instanceof ApiClientError)) return { reason: "unknown" };
  let reason: UploadFailure["reason"] = "unknown";
  if (error.status === 401) reason = "login";
  else if (error.status === 403) reason = "forbidden";
  else if (error.status === 404) reason = "missingProject";
  else if (error.status === 413) reason = "tooLarge";
  else if (error.status === 429) reason = "busy";
  else if (error.status >= 500) reason = "server";
  else if (error.status === 0 || error.code === "NETWORK_ERROR") reason = "network";
  else if (error.code === "UNSUPPORTED_MEDIA_TYPE") reason = "unsupported";
  else if (error.code === "MEDIA_TYPE_MISMATCH") reason = "mismatch";
  else if (error.code === "EMPTY_FILE") reason = "empty";
  else if (error.code === "PAYLOAD_TOO_LARGE" || error.code === "FILE_TOO_LARGE") reason = "tooLarge";
  return { reason, ...(requestIdPattern.test(error.requestId) ? { requestId: error.requestId } : {}) };
}

export function uploadFailureMessage(failure: UploadFailure | undefined): string {
  const message = failure && Object.hasOwn(messages, failure.reason) ? messages[failure.reason] : messages.unknown;
  return failure?.requestId && requestIdPattern.test(failure.requestId)
    ? `${message}（请求编号：${failure.requestId}）`
    : message;
}
